import { useState, useEffect } from 'react';

const LSC_NEXT = 'lscNext_';
/**
 * @param {string} key
 * @param {*} initialState
 * @param {function():Promise<*>} expensiveAsyncOperation
 * @returns {*}
 */
export function useLocalStorageCache(
  key,
  initialState,
  expensiveAsyncOperation
) {
  // Add a unique prefix to the key to avoid conflicts with other libraries
  key = LSC_NEXT + key;

  let needsExpensiveOp = true;

  // Refresh initial state from localStorage if possible
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      const storageValue = window.localStorage.getItem(key);
      if (storageValue !== null) {
        initialState = JSON.parse(storageValue);
        needsExpensiveOp = false;
      }
    }
  } catch {
    // Most likely quota exceeded or security errors, not fatal
  }

  // Persist value in memory
  const [value, setValue] = useState(initialState);

  // Update local storage when state changes
  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // Most likely quota exceeded or security errors, not fatal
    }
  }, [value]);

  // Do expensive async operation once
  useEffect(() => {
    if (needsExpensiveOp) {
      expensiveAsyncOperation()
        .then(newValue => {
          setValue(newValue);
        })
        .catch(e => {
          console.error(e);
        });
    }
  }, [needsExpensiveOp]);

  return value;
}

export function removeFromLocalStorageCache(key) {
  try {
    window.localStorage.removeItem(LSC_NEXT + key);
  } catch (e) {
    // Do nothing.
  }
}

module.exports = { removeFromLocalStorageCache, useLocalStorageCache };
